import noop from '../../Utilities/noop';
export const NullLogger = Object.freeze({
    debug: noop,
    debugError: noop,
    error: noop,
    errorError: noop,
    info: noop,
    infoError: noop,
    trace: noop,
    traceError: noop,
    warn: noop,
    warnError: noop,
    scope: () => Object.assign({ dispose: noop }, _defaultLogger),
});
let _defaultLogger = NullLogger;
export function getDefaultLogger() {
    return _defaultLogger;
}
export function setDefaultLogger(logger) {
    _defaultLogger = logger;
}
